module.exports = __webpack_public_path__ + "static/img/wechat_qrcode.9fecae66.png";